import { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  dateNavigator: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export const DateNavigationButtonComponent = (
  props: DateNavigator.NavigationButtonProps
) => {
  const { classes } = useStyles();
  return (
    <DateNavigator.NavigationButton
      className={classes.dateNavigator}
      {...props}
    ></DateNavigator.NavigationButton>
  );
};
